import { render, staticRenderFns } from "./PerformanceByDirection.vue?vue&type=template&id=28b105d0&"
import script from "./PerformanceByDirection.vue?vue&type=script&lang=js&"
export * from "./PerformanceByDirection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports